.filter {
    z-index: 10;

    &[data-sticky="true"] {
        position: sticky;
        top: 0;
    }
}


.xs {

    :global {
        margin: 0;

        .ant-table-measure-row {
            display: none;
        }

        .ant-table thead>tr>th {
            background: transparent;
        }

        th,
        tr td {
            padding: 5px 1px !important;
            font-size: 12px;
        }
    }
}

.noRowBorder {

    :global {

        .ant-table {
            border: 0;
            font-size: 13px;
        }

        .ant-table-tbody>tr>td,
        .ant-table-thead>tr>th {
            border: 0;
        }
    }
}